export const DEFAULT_FIREBASE_REGION = 'europe-central2'; // Warsaw
